/* eslint-disable simple-import-sort/imports */
/* eslint-disable curly */
// This code is generated automatically. Do not modify it manually.
// The suppressions below are required to suppress false positive ESLint warnings.
//
// Generated: Mon, 24 Nov 2025 17:04:18 GMT
//
// noinspection RedundantIfStatementJS, JSUnusedGlobalSymbols, DuplicatedCode
//
import {
  BlockchainInfo,
  BlockOperationType,
  ChargeModeType,
  ConversionDetails,
  ExpectedSettlementTimeDetails,
  ExpectedSettlementTimeType,
  FeeDetails,
  FeeType,
  FixedFee,
  From,
  IntegratorFee,
  IntegratorOperation,
  isAccountOrNull,
  isLocalInfo,
  MarketExecutionType,
  MockDepositRequest,
  OldFee,
  PercentageFee,
  PixInLocalInfo,
  PixOutLocalInfo,
  SimplifiedTransactionStatus,
  SpeiInLocalInfo,
  SpeiOutLocalInfo,
  SpreadFee,
  StatusType,
  SwiftLocalInfo,
  To,
  Transaction,
  TransactionDetails,
  TransactionDocument,
  TransactionEtaResponse,
  TransactionNotification,
  TransactionRequest,
  TransactionResponse,
  TransactionType,
  TransactionWithDocuments,
} from '@/types/transaction';
import {
  isBoolean,
  isFile,
  isNumber,
  isReadonlyArray,
  isString,
  isStringOrNull,
} from '@/types/common-type-guards';
import { isFiatAccountTypeOrNull } from '@/types/fiatAccountType.ext';
import { isAmount } from '@/types/amount';
import { isFiatAccount } from '@/types/contacts.ext';
import { isNotNullable, isNotNullableOrNull } from '@/types/notNullable';
import { isCurrencyCodeType, isPaymentRailType } from '@/types/currency.ext';

const valuesOfStatusType: readonly string[] = [
  'CREATED',
  'PENDING',
  'SUCCEEDED',
  'WAITING_WEBHOOK',
  'FAILED',
  'EXPIRED',
  'CANCELLED',
  'REJECTED',
  'DEPOSIT_RECEIVED',
  'DEPOSIT_COMPLETED',
  'PAYMENT_UNDER_REVIEW',
  'PROCESSED_BY_BANK',
  'PROCESSED_BY_INTERMEDIARY_BANK',
  'RECEIVED_BY_INTERMEDIARY_BANK',
  'RECEIVED_BY_BENEFICIARY_BANK',
];

export const isStatusType = (value: unknown): value is StatusType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfStatusType.includes(value);
};

export const isStatusTypeOrNull = (value: unknown): value is StatusType | null => {
  return value === null || isStatusType(value);
};

export const isArrayOfStatusType = (value: unknown): value is StatusType[] => {
  return Array.isArray(value) && value.every(isStatusType);
};

export const isArrayOfStatusTypeOrNull = (value: unknown): value is StatusType[] | null => {
  return value === null || isArrayOfStatusType(value);
};

const valuesOfIntegratorOperation: readonly string[] = [
  'ON_RAMP',
  'ON_RAMP_DEPOSIT_RECEIVED',
  'OFF_RAMP',
  'PAYMENT_IN',
  'PAYMENT_OUT',
  'BENEFICIARY_BANK_ACCOUNT_VALIDATION',
  'JUMIO_PROXY',
  'BENEFICIARY_KYC',
  'BENEFICIARY_KYB',
  'BENEFICIARY_APPROVED',
  'PIX_DEPOSIT_RECEIVED',
  'WIRE_DEPOSIT_RECEIVED',
  'SPEI_DEPOSIT_RECEIVED',
  'CRYPTO_DEPOSIT_RECEIVED',
  'TRANSACTION_COMPLETED',
  'TRANSACTION_FAILED',
  'TRANSACTION_EXPIRED',
  'TRANSACTION_SETTLED',
];

export const isIntegratorOperation = (value: unknown): value is IntegratorOperation => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfIntegratorOperation.includes(value);
};

export const isIntegratorOperationOrNull = (
  value: unknown,
): value is IntegratorOperation | null => {
  return value === null || isIntegratorOperation(value);
};

export const isArrayOfIntegratorOperation = (value: unknown): value is IntegratorOperation[] => {
  return Array.isArray(value) && value.every(isIntegratorOperation);
};

export const isArrayOfIntegratorOperationOrNull = (
  value: unknown,
): value is IntegratorOperation[] | null => {
  return value === null || isArrayOfIntegratorOperation(value);
};

const valuesOfBlockOperationType: readonly string[] = [
  'DEPOSIT',
  'EXCHANGE',
  'WITHDRAWAL',
  'TRANSFER',
  'EXTERNAL_TRANSFER',
  'OPEN_EXCHANGE',
  'CLOSE_EXCHANGE',
];

export const isBlockOperationType = (value: unknown): value is BlockOperationType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfBlockOperationType.includes(value);
};

export const isBlockOperationTypeOrNull = (value: unknown): value is BlockOperationType | null => {
  return value === null || isBlockOperationType(value);
};

export const isArrayOfBlockOperationType = (value: unknown): value is BlockOperationType[] => {
  return Array.isArray(value) && value.every(isBlockOperationType);
};

export const isArrayOfBlockOperationTypeOrNull = (
  value: unknown,
): value is BlockOperationType[] | null => {
  return value === null || isArrayOfBlockOperationType(value);
};

const valuesOfTransactionType: readonly string[] = [
  'TRANSFER',
  'WITHDRAWAL',
  'DEPOSIT',
  'EXCHANGE',
  'ALL',
];

export const isTransactionType = (value: unknown): value is TransactionType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfTransactionType.includes(value);
};

export const isTransactionTypeOrNull = (value: unknown): value is TransactionType | null => {
  return value === null || isTransactionType(value);
};

export const isArrayOfTransactionType = (value: unknown): value is TransactionType[] => {
  return Array.isArray(value) && value.every(isTransactionType);
};

export const isArrayOfTransactionTypeOrNull = (
  value: unknown,
): value is TransactionType[] | null => {
  return value === null || isArrayOfTransactionType(value);
};

const valuesOfSimplifiedTransactionStatus: readonly string[] = [
  'COMPLETED',
  'FAILED',
  'EXPIRED',
  'IN_PROGRESS',
  'CREATED',
  'ALL',
];

export const isSimplifiedTransactionStatus = (
  value: unknown,
): value is SimplifiedTransactionStatus => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfSimplifiedTransactionStatus.includes(value);
};

export const isSimplifiedTransactionStatusOrNull = (
  value: unknown,
): value is SimplifiedTransactionStatus | null => {
  return value === null || isSimplifiedTransactionStatus(value);
};

export const isArrayOfSimplifiedTransactionStatus = (
  value: unknown,
): value is SimplifiedTransactionStatus[] => {
  return Array.isArray(value) && value.every(isSimplifiedTransactionStatus);
};

export const isArrayOfSimplifiedTransactionStatusOrNull = (
  value: unknown,
): value is SimplifiedTransactionStatus[] | null => {
  return value === null || isArrayOfSimplifiedTransactionStatus(value);
};

const valuesOfExpectedSettlementTimeType: readonly string[] = [
  'INSTANT_MARKET_HOURS',
  'INSTANT',
  'WITHIN_5_MINUTES',
  'WITHIN_15_MINUTES',
  'SAME_DAY_BEFORE_CUTOFF',
  'ONE_TO_TWO_DAYS',
  'ONE_TO_THREE_DAYS',
  'UNKNOWN',
];

export const isExpectedSettlementTimeType = (
  value: unknown,
): value is ExpectedSettlementTimeType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfExpectedSettlementTimeType.includes(value);
};

export const isExpectedSettlementTimeTypeOrNull = (
  value: unknown,
): value is ExpectedSettlementTimeType | null => {
  return value === null || isExpectedSettlementTimeType(value);
};

export const isArrayOfExpectedSettlementTimeType = (
  value: unknown,
): value is ExpectedSettlementTimeType[] => {
  return Array.isArray(value) && value.every(isExpectedSettlementTimeType);
};

export const isArrayOfExpectedSettlementTimeTypeOrNull = (
  value: unknown,
): value is ExpectedSettlementTimeType[] | null => {
  return value === null || isArrayOfExpectedSettlementTimeType(value);
};

const valuesOfFeeType: readonly string[] = [
  '',
  'INTEGRATOR',
  'CALIZA',
  'TAX',
  'EXCHANGE',
  'NETWORK',
  'WITHDRAWAL',
  'TRANSFER',
  'CONVERSION_FEE_ESTIMATED',
  'POST_BUSINESS_HOURS',
  'CALIZA_DEPOSIT',
  'CALIZA_WITHDRAWAL',
  'CALIZA_SPREAD',
  'PRE_FIXED',
  'POST_FIXED',
];

export const isFeeType = (value: unknown): value is FeeType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfFeeType.includes(value);
};

export const isFeeTypeOrNull = (value: unknown): value is FeeType | null => {
  return value === null || isFeeType(value);
};

export const isArrayOfFeeType = (value: unknown): value is FeeType[] => {
  return Array.isArray(value) && value.every(isFeeType);
};

export const isArrayOfFeeTypeOrNull = (value: unknown): value is FeeType[] | null => {
  return value === null || isArrayOfFeeType(value);
};

const valuesOfChargeModeType: readonly string[] = ['POST_PAID', 'PRE_PAID'];

export const isChargeModeType = (value: unknown): value is ChargeModeType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfChargeModeType.includes(value);
};

export const isChargeModeTypeOrNull = (value: unknown): value is ChargeModeType | null => {
  return value === null || isChargeModeType(value);
};

export const isArrayOfChargeModeType = (value: unknown): value is ChargeModeType[] => {
  return Array.isArray(value) && value.every(isChargeModeType);
};

export const isArrayOfChargeModeTypeOrNull = (value: unknown): value is ChargeModeType[] | null => {
  return value === null || isArrayOfChargeModeType(value);
};

const valuesOfMarketExecutionType: readonly string[] = [
  'EXECUTE_IMMEDIATELY',
  'MARKET_OPEN_TIME',
  'NONE',
];

export const isMarketExecutionType = (value: unknown): value is MarketExecutionType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfMarketExecutionType.includes(value);
};

export const isMarketExecutionTypeOrNull = (
  value: unknown,
): value is MarketExecutionType | null => {
  return value === null || isMarketExecutionType(value);
};

export const isArrayOfMarketExecutionType = (value: unknown): value is MarketExecutionType[] => {
  return Array.isArray(value) && value.every(isMarketExecutionType);
};

export const isArrayOfMarketExecutionTypeOrNull = (
  value: unknown,
): value is MarketExecutionType[] | null => {
  return value === null || isArrayOfMarketExecutionType(value);
};

export const isTransactionNotification = (value: unknown): value is TransactionNotification => {
  if (value === null || typeof value !== 'object') return false;
  if (!('status' in value && isStatusType(value.status))) return false;
  if (!('operation' in value && isIntegratorOperation(value.operation))) return false;

  return true;
};

export const isTransactionNotificationOrNull = (
  value: unknown,
): value is TransactionNotification | null => {
  return value === null || isTransactionNotification(value);
};

export const isArrayOfTransactionNotification = (
  value: unknown,
): value is readonly TransactionNotification[] => {
  return Array.isArray(value) && value.every(isTransactionNotification);
};

export const isArrayOfTransactionNotificationOrNull = (
  value: unknown,
): value is readonly TransactionNotification[] | null => {
  return value === null || isArrayOfTransactionNotification(value);
};

const propertiesOfTransactionNotification: readonly string[] = ['status', 'operation'];

export const isKeyOfTransactionNotification = (
  value: unknown,
): value is keyof TransactionNotification => {
  return typeof value === 'string' && propertiesOfTransactionNotification.includes(value);
};

export const isBlockchainInfo = (value: unknown): value is BlockchainInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('depositTransactionHash' in value && isStringOrNull(value.depositTransactionHash)))
    return false;
  if (!('fundingWallet' in value && isStringOrNull(value.fundingWallet))) return false;
  if (!('targetWallet' in value && isStringOrNull(value.targetWallet))) return false;
  if (!('withdrawalTransactionHash' in value && isStringOrNull(value.withdrawalTransactionHash)))
    return false;

  return true;
};

export const isBlockchainInfoOrNull = (value: unknown): value is BlockchainInfo | null => {
  return value === null || isBlockchainInfo(value);
};

export const isArrayOfBlockchainInfo = (value: unknown): value is readonly BlockchainInfo[] => {
  return Array.isArray(value) && value.every(isBlockchainInfo);
};

export const isArrayOfBlockchainInfoOrNull = (
  value: unknown,
): value is readonly BlockchainInfo[] | null => {
  return value === null || isArrayOfBlockchainInfo(value);
};

const propertiesOfBlockchainInfo: readonly string[] = [
  'depositTransactionHash',
  'fundingWallet',
  'targetWallet',
  'withdrawalTransactionHash',
];

export const isKeyOfBlockchainInfo = (value: unknown): value is keyof BlockchainInfo => {
  return typeof value === 'string' && propertiesOfBlockchainInfo.includes(value);
};

export const isTransaction = (value: unknown): value is Transaction => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isString(value.id))) return false;
  if (!('date' in value && isString(value.date))) return false;
  if (!('status' in value && isStatusType(value.status))) return false;
  if (!('type' in value && isTransactionType(value.type))) return false;
  if (!('paymentType' in value && isFiatAccountTypeOrNull(value.paymentType))) return false;
  if (!('fromAccountAlias' in value && isStringOrNull(value.fromAccountAlias))) return false;
  if (!('fromAccount' in value && isAccountOrNull(value.fromAccount))) return false;
  if (!('fromAmount' in value && isAmount(value.fromAmount))) return false;
  if (!('toAccountAlias' in value && isStringOrNull(value.toAccountAlias))) return false;
  if (!('toAccount' in value && isAccountOrNull(value.toAccount))) return false;
  if (!('toAmount' in value && isAmount(value.toAmount))) return false;
  if (!('localInfo' in value && isLocalInfo(value.localInfo))) return false;
  if (!('transactionDetails' in value && isTransactionDetails(value.transactionDetails)))
    return false;
  if (!('initiatedBy' in value && isStringOrNull(value.initiatedBy))) return false;
  if (!('completed' in value && isBoolean(value.completed))) return false;

  return true;
};

export const isTransactionOrNull = (value: unknown): value is Transaction | null => {
  return value === null || isTransaction(value);
};

export const isArrayOfTransaction = (value: unknown): value is readonly Transaction[] => {
  return Array.isArray(value) && value.every(isTransaction);
};

export const isArrayOfTransactionOrNull = (
  value: unknown,
): value is readonly Transaction[] | null => {
  return value === null || isArrayOfTransaction(value);
};

const propertiesOfTransaction: readonly string[] = [
  'id',
  'date',
  'status',
  'type',
  'paymentType',
  'fromAccountAlias',
  'fromAccount',
  'fromAmount',
  'toAccountAlias',
  'toAccount',
  'toAmount',
  'localInfo',
  'transactionDetails',
  'initiatedBy',
  'completed',
];

export const isKeyOfTransaction = (value: unknown): value is keyof Transaction => {
  return typeof value === 'string' && propertiesOfTransaction.includes(value);
};

export const isTransactionResponse = (value: unknown): value is TransactionResponse => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isString(value.id))) return false;
  if (!('simulationId' in value && isString(value.simulationId))) return false;
  if (!('integratorId' in value && isString(value.integratorId))) return false;
  if (!('beneficiaryId' in value && isString(value.beneficiaryId))) return false;
  if (!('from' in value && isFrom(value.from))) return false;
  if (!('to' in value && isTo(value.to))) return false;
  if (!('status' in value && isString(value.status))) return false;
  if (!('blockchainInfo' in value && isBlockchainInfo(value.blockchainInfo))) return false;
  if (!('localInfo' in value && isLocalInfo(value.localInfo))) return false;
  if (!('beneficiaryIp' in value && isString(value.beneficiaryIp))) return false;
  if (!('flowOfFundsId' in value && isString(value.flowOfFundsId))) return false;
  if (!('transactionDetails' in value && isTransactionDetails(value.transactionDetails)))
    return false;
  if (!('createdDate' in value && isString(value.createdDate))) return false;
  if (!('lastModifiedDate' in value && isString(value.lastModifiedDate))) return false;

  return true;
};

export const isTransactionResponseOrNull = (
  value: unknown,
): value is TransactionResponse | null => {
  return value === null || isTransactionResponse(value);
};

export const isArrayOfTransactionResponse = (
  value: unknown,
): value is readonly TransactionResponse[] => {
  return Array.isArray(value) && value.every(isTransactionResponse);
};

export const isArrayOfTransactionResponseOrNull = (
  value: unknown,
): value is readonly TransactionResponse[] | null => {
  return value === null || isArrayOfTransactionResponse(value);
};

const propertiesOfTransactionResponse: readonly string[] = [
  'id',
  'simulationId',
  'integratorId',
  'beneficiaryId',
  'from',
  'to',
  'status',
  'blockchainInfo',
  'localInfo',
  'beneficiaryIp',
  'flowOfFundsId',
  'transactionDetails',
  'createdDate',
  'lastModifiedDate',
];

export const isKeyOfTransactionResponse = (value: unknown): value is keyof TransactionResponse => {
  return typeof value === 'string' && propertiesOfTransactionResponse.includes(value);
};

export const isFrom = (value: unknown): value is From => {
  if (value === null || typeof value !== 'object') return false;
  if (!('currencyCode' in value && isString(value.currencyCode))) return false;
  if (!('value' in value && isString(value.value))) return false;

  return true;
};

export const isFromOrNull = (value: unknown): value is From | null => {
  return value === null || isFrom(value);
};

export const isArrayOfFrom = (value: unknown): value is readonly From[] => {
  return Array.isArray(value) && value.every(isFrom);
};

export const isArrayOfFromOrNull = (value: unknown): value is readonly From[] | null => {
  return value === null || isArrayOfFrom(value);
};

const propertiesOfFrom: readonly string[] = ['currencyCode', 'value'];

export const isKeyOfFrom = (value: unknown): value is keyof From => {
  return typeof value === 'string' && propertiesOfFrom.includes(value);
};

export const isTo = (value: unknown): value is To => {
  if (value === null || typeof value !== 'object') return false;
  if (!('currencyCode' in value && isString(value.currencyCode))) return false;
  if (!('value' in value && isString(value.value))) return false;

  return true;
};

export const isToOrNull = (value: unknown): value is To | null => {
  return value === null || isTo(value);
};

export const isArrayOfTo = (value: unknown): value is readonly To[] => {
  return Array.isArray(value) && value.every(isTo);
};

export const isArrayOfToOrNull = (value: unknown): value is readonly To[] | null => {
  return value === null || isArrayOfTo(value);
};

const propertiesOfTo: readonly string[] = ['currencyCode', 'value'];

export const isKeyOfTo = (value: unknown): value is keyof To => {
  return typeof value === 'string' && propertiesOfTo.includes(value);
};

export const isSpeiInLocalInfo = (value: unknown): value is SpeiInLocalInfo => {
  if (value === null || typeof value !== 'object') return false;
  if ('speiInClabe' in value && !isString(value.speiInClabe)) return false;
  if (!('speiInBankName' in value && isString(value.speiInBankName))) return false;
  if (!('speiInBeneficiaryName' in value && isString(value.speiInBeneficiaryName))) return false;

  return true;
};

export const isSpeiInLocalInfoOrNull = (value: unknown): value is SpeiInLocalInfo | null => {
  return value === null || isSpeiInLocalInfo(value);
};

export const isArrayOfSpeiInLocalInfo = (value: unknown): value is readonly SpeiInLocalInfo[] => {
  return Array.isArray(value) && value.every(isSpeiInLocalInfo);
};

export const isArrayOfSpeiInLocalInfoOrNull = (
  value: unknown,
): value is readonly SpeiInLocalInfo[] | null => {
  return value === null || isArrayOfSpeiInLocalInfo(value);
};

const propertiesOfSpeiInLocalInfo: readonly string[] = [
  'speiInClabe',
  'speiInBankName',
  'speiInBeneficiaryName',
];

export const isKeyOfSpeiInLocalInfo = (value: unknown): value is keyof SpeiInLocalInfo => {
  return typeof value === 'string' && propertiesOfSpeiInLocalInfo.includes(value);
};

export const isSpeiOutLocalInfo = (value: unknown): value is SpeiOutLocalInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('speiOutClabe' in value && isString(value.speiOutClabe))) return false;
  if (!('speiOutSearchableId' in value && isString(value.speiOutSearchableId))) return false;

  return true;
};

export const isSpeiOutLocalInfoOrNull = (value: unknown): value is SpeiOutLocalInfo | null => {
  return value === null || isSpeiOutLocalInfo(value);
};

export const isArrayOfSpeiOutLocalInfo = (value: unknown): value is readonly SpeiOutLocalInfo[] => {
  return Array.isArray(value) && value.every(isSpeiOutLocalInfo);
};

export const isArrayOfSpeiOutLocalInfoOrNull = (
  value: unknown,
): value is readonly SpeiOutLocalInfo[] | null => {
  return value === null || isArrayOfSpeiOutLocalInfo(value);
};

const propertiesOfSpeiOutLocalInfo: readonly string[] = ['speiOutClabe', 'speiOutSearchableId'];

export const isKeyOfSpeiOutLocalInfo = (value: unknown): value is keyof SpeiOutLocalInfo => {
  return typeof value === 'string' && propertiesOfSpeiOutLocalInfo.includes(value);
};

export const isPixInLocalInfo = (value: unknown): value is PixInLocalInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('pixCopyAndPaste' in value && isString(value.pixCopyAndPaste))) return false;
  if (!('pixExpiresAt' in value && isString(value.pixExpiresAt))) return false;

  return true;
};

export const isPixInLocalInfoOrNull = (value: unknown): value is PixInLocalInfo | null => {
  return value === null || isPixInLocalInfo(value);
};

export const isArrayOfPixInLocalInfo = (value: unknown): value is readonly PixInLocalInfo[] => {
  return Array.isArray(value) && value.every(isPixInLocalInfo);
};

export const isArrayOfPixInLocalInfoOrNull = (
  value: unknown,
): value is readonly PixInLocalInfo[] | null => {
  return value === null || isArrayOfPixInLocalInfo(value);
};

const propertiesOfPixInLocalInfo: readonly string[] = ['pixCopyAndPaste', 'pixExpiresAt'];

export const isKeyOfPixInLocalInfo = (value: unknown): value is keyof PixInLocalInfo => {
  return typeof value === 'string' && propertiesOfPixInLocalInfo.includes(value);
};

export const isPixOutLocalInfo = (value: unknown): value is PixOutLocalInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('targetPixKey' in value && isString(value.targetPixKey))) return false;
  if (!('pixOutSearchableId' in value && isString(value.pixOutSearchableId))) return false;

  return true;
};

export const isPixOutLocalInfoOrNull = (value: unknown): value is PixOutLocalInfo | null => {
  return value === null || isPixOutLocalInfo(value);
};

export const isArrayOfPixOutLocalInfo = (value: unknown): value is readonly PixOutLocalInfo[] => {
  return Array.isArray(value) && value.every(isPixOutLocalInfo);
};

export const isArrayOfPixOutLocalInfoOrNull = (
  value: unknown,
): value is readonly PixOutLocalInfo[] | null => {
  return value === null || isArrayOfPixOutLocalInfo(value);
};

const propertiesOfPixOutLocalInfo: readonly string[] = ['targetPixKey', 'pixOutSearchableId'];

export const isKeyOfPixOutLocalInfo = (value: unknown): value is keyof PixOutLocalInfo => {
  return typeof value === 'string' && propertiesOfPixOutLocalInfo.includes(value);
};

export const isSwiftLocalInfo = (value: unknown): value is SwiftLocalInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('destinationFiatAccount' in value && isFiatAccount(value.destinationFiatAccount)))
    return false;
  if (!('uetr' in value && isString(value.uetr))) return false;

  return true;
};

export const isSwiftLocalInfoOrNull = (value: unknown): value is SwiftLocalInfo | null => {
  return value === null || isSwiftLocalInfo(value);
};

export const isArrayOfSwiftLocalInfo = (value: unknown): value is readonly SwiftLocalInfo[] => {
  return Array.isArray(value) && value.every(isSwiftLocalInfo);
};

export const isArrayOfSwiftLocalInfoOrNull = (
  value: unknown,
): value is readonly SwiftLocalInfo[] | null => {
  return value === null || isArrayOfSwiftLocalInfo(value);
};

const propertiesOfSwiftLocalInfo: readonly string[] = ['destinationFiatAccount', 'uetr'];

export const isKeyOfSwiftLocalInfo = (value: unknown): value is keyof SwiftLocalInfo => {
  return typeof value === 'string' && propertiesOfSwiftLocalInfo.includes(value);
};

export const isExpectedSettlementTimeDetails = (
  value: unknown,
): value is ExpectedSettlementTimeDetails => {
  if (value === null || typeof value !== 'object') return false;
  if (!('expectedTime' in value && isExpectedSettlementTimeType(value.expectedTime))) return false;
  if (!('displayText' in value && isString(value.displayText))) return false;
  if ('additionalInfo' in value && !isString(value.additionalInfo)) return false;
  if ('cutoffTime' in value && !isString(value.cutoffTime)) return false;

  return true;
};

export const isExpectedSettlementTimeDetailsOrNull = (
  value: unknown,
): value is ExpectedSettlementTimeDetails | null => {
  return value === null || isExpectedSettlementTimeDetails(value);
};

export const isArrayOfExpectedSettlementTimeDetails = (
  value: unknown,
): value is readonly ExpectedSettlementTimeDetails[] => {
  return Array.isArray(value) && value.every(isExpectedSettlementTimeDetails);
};

export const isArrayOfExpectedSettlementTimeDetailsOrNull = (
  value: unknown,
): value is readonly ExpectedSettlementTimeDetails[] | null => {
  return value === null || isArrayOfExpectedSettlementTimeDetails(value);
};

const propertiesOfExpectedSettlementTimeDetails: readonly string[] = [
  'expectedTime',
  'displayText',
  'additionalInfo',
  'cutoffTime',
];

export const isKeyOfExpectedSettlementTimeDetails = (
  value: unknown,
): value is keyof ExpectedSettlementTimeDetails => {
  return typeof value === 'string' && propertiesOfExpectedSettlementTimeDetails.includes(value);
};

export const isTransactionDetails = (value: unknown): value is TransactionDetails => {
  if (value === null || typeof value !== 'object') return false;
  if ('conversionDetails' in value && !isConversionDetailsOrNull(value.conversionDetails))
    return false;
  if (!('feeDetails' in value && isFeeDetails(value.feeDetails))) return false;
  if (!('transferPurpose' in value && isStringOrNull(value.transferPurpose))) return false;
  if (!('paymentReference' in value && isStringOrNull(value.paymentReference))) return false;
  if (!('memo' in value && isStringOrNull(value.memo))) return false;
  if (
    !(
      'expectedSettlementTimeDetails' in value &&
      isExpectedSettlementTimeDetailsOrNull(value.expectedSettlementTimeDetails)
    )
  )
    return false;

  return true;
};

export const isTransactionDetailsOrNull = (value: unknown): value is TransactionDetails | null => {
  return value === null || isTransactionDetails(value);
};

export const isArrayOfTransactionDetails = (
  value: unknown,
): value is readonly TransactionDetails[] => {
  return Array.isArray(value) && value.every(isTransactionDetails);
};

export const isArrayOfTransactionDetailsOrNull = (
  value: unknown,
): value is readonly TransactionDetails[] | null => {
  return value === null || isArrayOfTransactionDetails(value);
};

const propertiesOfTransactionDetails: readonly string[] = [
  'conversionDetails',
  'feeDetails',
  'transferPurpose',
  'paymentReference',
  'memo',
  'expectedSettlementTimeDetails',
];

export const isKeyOfTransactionDetails = (value: unknown): value is keyof TransactionDetails => {
  return typeof value === 'string' && propertiesOfTransactionDetails.includes(value);
};

export const isConversionDetails = (value: unknown): value is ConversionDetails => {
  if (value === null || typeof value !== 'object') return false;
  if (!('effectiveTransactionValue' in value && isNumber(value.effectiveTransactionValue)))
    return false;
  if (!('marketExchangeRate' in value && isNumber(value.marketExchangeRate))) return false;
  if (!('clientRate' in value && isNumber(value.clientRate))) return false;
  if (!('calizaRate' in value && isNumber(value.calizaRate))) return false;
  if (!('amountToBeConverted' in value && isNotNullable(value.amountToBeConverted))) return false;

  return true;
};

export const isConversionDetailsOrNull = (value: unknown): value is ConversionDetails | null => {
  return value === null || isConversionDetails(value);
};

export const isArrayOfConversionDetails = (
  value: unknown,
): value is readonly ConversionDetails[] => {
  return Array.isArray(value) && value.every(isConversionDetails);
};

export const isArrayOfConversionDetailsOrNull = (
  value: unknown,
): value is readonly ConversionDetails[] | null => {
  return value === null || isArrayOfConversionDetails(value);
};

const propertiesOfConversionDetails: readonly string[] = [
  'effectiveTransactionValue',
  'marketExchangeRate',
  'clientRate',
  'calizaRate',
  'amountToBeConverted',
];

export const isKeyOfConversionDetails = (value: unknown): value is keyof ConversionDetails => {
  return typeof value === 'string' && propertiesOfConversionDetails.includes(value);
};

export const isFixedFee = (value: unknown): value is FixedFee => {
  if (value === null || typeof value !== 'object') return false;
  if (!('block' in value && isBlockOperationType(value.block))) return false;
  if (!('type' in value && isFeeType(value.type))) return false;
  if (!('value' in value && isString(value.value))) return false;
  if (!('currencyCode' in value && isCurrencyCodeType(value.currencyCode))) return false;
  if (!('concept' in value && isString(value.concept))) return false;
  if (!('paymentRail' in value && isPaymentRailType(value.paymentRail))) return false;
  if (!('chargeMode' in value && isChargeModeType(value.chargeMode))) return false;

  return true;
};

export const isFixedFeeOrNull = (value: unknown): value is FixedFee | null => {
  return value === null || isFixedFee(value);
};

export const isArrayOfFixedFee = (value: unknown): value is readonly FixedFee[] => {
  return Array.isArray(value) && value.every(isFixedFee);
};

export const isArrayOfFixedFeeOrNull = (value: unknown): value is readonly FixedFee[] | null => {
  return value === null || isArrayOfFixedFee(value);
};

const propertiesOfFixedFee: readonly string[] = [
  'block',
  'type',
  'value',
  'currencyCode',
  'concept',
  'paymentRail',
  'chargeMode',
];

export const isKeyOfFixedFee = (value: unknown): value is keyof FixedFee => {
  return typeof value === 'string' && propertiesOfFixedFee.includes(value);
};

export const isPercentageFee = (value: unknown): value is PercentageFee => {
  if (value === null || typeof value !== 'object') return false;
  if (!('block' in value && isBlockOperationType(value.block))) return false;
  if (!('type' in value && isFeeType(value.type))) return false;
  if (!('percentageRate' in value && isString(value.percentageRate))) return false;
  if (!('baseAmount' in value && isString(value.baseAmount))) return false;
  if (!('baseCurrency' in value && isCurrencyCodeType(value.baseCurrency))) return false;
  if (!('calculatedFee' in value && isString(value.calculatedFee))) return false;
  if (!('feeCurrency' in value && isCurrencyCodeType(value.feeCurrency))) return false;
  if (!('concept' in value && isString(value.concept))) return false;
  if (!('paymentRail' in value && isPaymentRailType(value.paymentRail))) return false;
  if (!('chargeMode' in value && isChargeModeType(value.chargeMode))) return false;

  return true;
};

export const isPercentageFeeOrNull = (value: unknown): value is PercentageFee | null => {
  return value === null || isPercentageFee(value);
};

export const isArrayOfPercentageFee = (value: unknown): value is readonly PercentageFee[] => {
  return Array.isArray(value) && value.every(isPercentageFee);
};

export const isArrayOfPercentageFeeOrNull = (
  value: unknown,
): value is readonly PercentageFee[] | null => {
  return value === null || isArrayOfPercentageFee(value);
};

const propertiesOfPercentageFee: readonly string[] = [
  'block',
  'type',
  'percentageRate',
  'baseAmount',
  'baseCurrency',
  'calculatedFee',
  'feeCurrency',
  'concept',
  'paymentRail',
  'chargeMode',
];

export const isKeyOfPercentageFee = (value: unknown): value is keyof PercentageFee => {
  return typeof value === 'string' && propertiesOfPercentageFee.includes(value);
};

export const isSpreadFee = (value: unknown): value is SpreadFee => {
  if (value === null || typeof value !== 'object') return false;
  if (!('block' in value && isBlockOperationType(value.block))) return false;
  if (!('type' in value && isFeeType(value.type))) return false;
  if (!('fromCurrency' in value && isCurrencyCodeType(value.fromCurrency))) return false;
  if (!('toCurrency' in value && isCurrencyCodeType(value.toCurrency))) return false;
  if (!('marketRate' in value && isString(value.marketRate))) return false;
  if (!('spreadBasisPoint' in value && isString(value.spreadBasisPoint))) return false;
  if (!('effectiveRate' in value && isString(value.effectiveRate))) return false;
  if (!('calizaRate' in value && isString(value.calizaRate))) return false;
  if (!('baseCurrency' in value && isCurrencyCodeType(value.baseCurrency))) return false;
  if (!('baseAmount' in value && isString(value.baseAmount))) return false;
  if (!('calculatedFee' in value && isString(value.calculatedFee))) return false;
  if (!('feeCurrency' in value && isCurrencyCodeType(value.feeCurrency))) return false;
  if (!('concept' in value && isString(value.concept))) return false;
  if (!('chargeMode' in value && isChargeModeType(value.chargeMode))) return false;

  return true;
};

export const isSpreadFeeOrNull = (value: unknown): value is SpreadFee | null => {
  return value === null || isSpreadFee(value);
};

export const isArrayOfSpreadFee = (value: unknown): value is readonly SpreadFee[] => {
  return Array.isArray(value) && value.every(isSpreadFee);
};

export const isArrayOfSpreadFeeOrNull = (value: unknown): value is readonly SpreadFee[] | null => {
  return value === null || isArrayOfSpreadFee(value);
};

const propertiesOfSpreadFee: readonly string[] = [
  'block',
  'type',
  'fromCurrency',
  'toCurrency',
  'marketRate',
  'spreadBasisPoint',
  'effectiveRate',
  'calizaRate',
  'baseCurrency',
  'baseAmount',
  'calculatedFee',
  'feeCurrency',
  'concept',
  'chargeMode',
];

export const isKeyOfSpreadFee = (value: unknown): value is keyof SpreadFee => {
  return typeof value === 'string' && propertiesOfSpreadFee.includes(value);
};

export const isOldFee = (value: unknown): value is OldFee => {
  if (value === null || typeof value !== 'object') return false;
  if (!('block' in value && isBlockOperationType(value.block))) return false;
  if (!('type' in value && isFeeType(value.type))) return false;
  if (!('fromCurrency' in value && isCurrencyCodeType(value.fromCurrency))) return false;
  if (!('toCurrency' in value && isCurrencyCodeType(value.toCurrency))) return false;
  if (!('feeValue' in value && isString(value.feeValue))) return false;
  if (!('feeCurrency' in value && isCurrencyCodeType(value.feeCurrency))) return false;
  if (!('marketRate' in value && isString(value.marketRate))) return false;
  if (!('effectiveRate' in value && isString(value.effectiveRate))) return false;
  if (!('calizaRate' in value && isString(value.calizaRate))) return false;
  if (!('baseCurrency' in value && isCurrencyCodeType(value.baseCurrency))) return false;
  if (!('baseAmount' in value && isString(value.baseAmount))) return false;
  if (!('concept' in value && isString(value.concept))) return false;
  if (!('chargeMode' in value && isChargeModeType(value.chargeMode))) return false;

  return true;
};

export const isOldFeeOrNull = (value: unknown): value is OldFee | null => {
  return value === null || isOldFee(value);
};

export const isArrayOfOldFee = (value: unknown): value is readonly OldFee[] => {
  return Array.isArray(value) && value.every(isOldFee);
};

export const isArrayOfOldFeeOrNull = (value: unknown): value is readonly OldFee[] | null => {
  return value === null || isArrayOfOldFee(value);
};

const propertiesOfOldFee: readonly string[] = [
  'block',
  'type',
  'fromCurrency',
  'toCurrency',
  'feeValue',
  'feeCurrency',
  'marketRate',
  'effectiveRate',
  'calizaRate',
  'baseCurrency',
  'baseAmount',
  'concept',
  'chargeMode',
];

export const isKeyOfOldFee = (value: unknown): value is keyof OldFee => {
  return typeof value === 'string' && propertiesOfOldFee.includes(value);
};

export const isFeeDetails = (value: unknown): value is FeeDetails => {
  if (value === null || typeof value !== 'object') return false;
  if (!('taxes' in value && isNotNullableOrNull(value.taxes))) return false;
  if (!('integratorFee' in value && isAmount(value.integratorFee))) return false;
  if (!('fixedFees' in value && isReadonlyArray(value.fixedFees))) return false;
  if (!('percentageFees' in value && isReadonlyArray(value.percentageFees))) return false;
  if (!('spreadFees' in value && isReadonlyArray(value.spreadFees))) return false;
  if (!('oldFees' in value && isReadonlyArray(value.oldFees))) return false;
  if (!('totalFees' in value && isNotNullable(value.totalFees))) return false;
  if (!('vet' in value && isString(value.vet))) return false;

  return true;
};

export const isFeeDetailsOrNull = (value: unknown): value is FeeDetails | null => {
  return value === null || isFeeDetails(value);
};

export const isArrayOfFeeDetails = (value: unknown): value is readonly FeeDetails[] => {
  return Array.isArray(value) && value.every(isFeeDetails);
};

export const isArrayOfFeeDetailsOrNull = (
  value: unknown,
): value is readonly FeeDetails[] | null => {
  return value === null || isArrayOfFeeDetails(value);
};

const propertiesOfFeeDetails: readonly string[] = [
  'taxes',
  'integratorFee',
  'fixedFees',
  'percentageFees',
  'spreadFees',
  'oldFees',
  'totalFees',
  'vet',
];

export const isKeyOfFeeDetails = (value: unknown): value is keyof FeeDetails => {
  return typeof value === 'string' && propertiesOfFeeDetails.includes(value);
};

export const isIntegratorFee = (value: unknown): value is IntegratorFee => {
  if (value === null || typeof value !== 'object') return false;
  if (!('currencyCode' in value && isString(value.currencyCode))) return false;
  if (!('value' in value && isString(value.value))) return false;

  return true;
};

export const isIntegratorFeeOrNull = (value: unknown): value is IntegratorFee | null => {
  return value === null || isIntegratorFee(value);
};

export const isArrayOfIntegratorFee = (value: unknown): value is readonly IntegratorFee[] => {
  return Array.isArray(value) && value.every(isIntegratorFee);
};

export const isArrayOfIntegratorFeeOrNull = (
  value: unknown,
): value is readonly IntegratorFee[] | null => {
  return value === null || isArrayOfIntegratorFee(value);
};

const propertiesOfIntegratorFee: readonly string[] = ['currencyCode', 'value'];

export const isKeyOfIntegratorFee = (value: unknown): value is keyof IntegratorFee => {
  return typeof value === 'string' && propertiesOfIntegratorFee.includes(value);
};

export const isTransactionRequest = (value: unknown): value is TransactionRequest => {
  if (value === null || typeof value !== 'object') return false;
  if (!('simulationId' in value && isString(value.simulationId))) return false;
  if (!('beneficiaryIp' in value && isString(value.beneficiaryIp))) return false;
  if (!('marketExecutionType' in value && isMarketExecutionType(value.marketExecutionType)))
    return false;
  if ('attachment' in value && !isFile(value.attachment)) return false;
  if ('transferPurpose' in value && !isString(value.transferPurpose)) return false;
  if ('paymentReference' in value && !isString(value.paymentReference)) return false;
  if ('memo' in value && !isString(value.memo)) return false;

  return true;
};

export const isTransactionRequestOrNull = (value: unknown): value is TransactionRequest | null => {
  return value === null || isTransactionRequest(value);
};

export const isArrayOfTransactionRequest = (
  value: unknown,
): value is readonly TransactionRequest[] => {
  return Array.isArray(value) && value.every(isTransactionRequest);
};

export const isArrayOfTransactionRequestOrNull = (
  value: unknown,
): value is readonly TransactionRequest[] | null => {
  return value === null || isArrayOfTransactionRequest(value);
};

const propertiesOfTransactionRequest: readonly string[] = [
  'simulationId',
  'beneficiaryIp',
  'marketExecutionType',
  'attachment',
  'transferPurpose',
  'paymentReference',
  'memo',
];

export const isKeyOfTransactionRequest = (value: unknown): value is keyof TransactionRequest => {
  return typeof value === 'string' && propertiesOfTransactionRequest.includes(value);
};

export const isTransactionDocument = (value: unknown): value is TransactionDocument => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isString(value.id))) return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('mimeType' in value && isString(value.mimeType))) return false;
  if (!('size' in value && isNumber(value.size))) return false;
  if ('uploadDate' in value && !isString(value.uploadDate)) return false;
  if ('viewUrl' in value && !isString(value.viewUrl)) return false;

  return true;
};

export const isTransactionDocumentOrNull = (
  value: unknown,
): value is TransactionDocument | null => {
  return value === null || isTransactionDocument(value);
};

export const isArrayOfTransactionDocument = (
  value: unknown,
): value is readonly TransactionDocument[] => {
  return Array.isArray(value) && value.every(isTransactionDocument);
};

export const isArrayOfTransactionDocumentOrNull = (
  value: unknown,
): value is readonly TransactionDocument[] | null => {
  return value === null || isArrayOfTransactionDocument(value);
};

const propertiesOfTransactionDocument: readonly string[] = [
  'id',
  'name',
  'mimeType',
  'size',
  'uploadDate',
  'viewUrl',
];

export const isKeyOfTransactionDocument = (value: unknown): value is keyof TransactionDocument => {
  return typeof value === 'string' && propertiesOfTransactionDocument.includes(value);
};

export const isTransactionWithDocuments = (value: unknown): value is TransactionWithDocuments => {
  if (value === null || typeof value !== 'object') return false;
  if (!('documents' in value && isArrayOfTransactionDocument(value.documents))) return false;

  return true;
};

export const isTransactionWithDocumentsOrNull = (
  value: unknown,
): value is TransactionWithDocuments | null => {
  return value === null || isTransactionWithDocuments(value);
};

export const isArrayOfTransactionWithDocuments = (
  value: unknown,
): value is readonly TransactionWithDocuments[] => {
  return Array.isArray(value) && value.every(isTransactionWithDocuments);
};

export const isArrayOfTransactionWithDocumentsOrNull = (
  value: unknown,
): value is readonly TransactionWithDocuments[] | null => {
  return value === null || isArrayOfTransactionWithDocuments(value);
};

const propertiesOfTransactionWithDocuments: readonly string[] = ['documents'];

export const isKeyOfTransactionWithDocuments = (
  value: unknown,
): value is keyof TransactionWithDocuments => {
  return typeof value === 'string' && propertiesOfTransactionWithDocuments.includes(value);
};

export const isMockDepositRequest = (value: unknown): value is MockDepositRequest => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && isString(value.type))) return false;
  if (!('transactionId' in value && isString(value.transactionId))) return false;
  if (!('documentId' in value && isString(value.documentId))) return false;

  return true;
};

export const isMockDepositRequestOrNull = (value: unknown): value is MockDepositRequest | null => {
  return value === null || isMockDepositRequest(value);
};

export const isArrayOfMockDepositRequest = (
  value: unknown,
): value is readonly MockDepositRequest[] => {
  return Array.isArray(value) && value.every(isMockDepositRequest);
};

export const isArrayOfMockDepositRequestOrNull = (
  value: unknown,
): value is readonly MockDepositRequest[] | null => {
  return value === null || isArrayOfMockDepositRequest(value);
};

const propertiesOfMockDepositRequest: readonly string[] = ['type', 'transactionId', 'documentId'];

export const isKeyOfMockDepositRequest = (value: unknown): value is keyof MockDepositRequest => {
  return typeof value === 'string' && propertiesOfMockDepositRequest.includes(value);
};

export const isTransactionEtaResponse = (value: unknown): value is TransactionEtaResponse => {
  if (value === null || typeof value !== 'object') return false;
  if (!('etaHours' in value && isNumber(value.etaHours))) return false;

  return true;
};

export const isTransactionEtaResponseOrNull = (
  value: unknown,
): value is TransactionEtaResponse | null => {
  return value === null || isTransactionEtaResponse(value);
};

export const isArrayOfTransactionEtaResponse = (
  value: unknown,
): value is readonly TransactionEtaResponse[] => {
  return Array.isArray(value) && value.every(isTransactionEtaResponse);
};

export const isArrayOfTransactionEtaResponseOrNull = (
  value: unknown,
): value is readonly TransactionEtaResponse[] | null => {
  return value === null || isArrayOfTransactionEtaResponse(value);
};

const propertiesOfTransactionEtaResponse: readonly string[] = ['etaHours'];

export const isKeyOfTransactionEtaResponse = (
  value: unknown,
): value is keyof TransactionEtaResponse => {
  return typeof value === 'string' && propertiesOfTransactionEtaResponse.includes(value);
};
